'use strict'

import angular from 'angular'

import buySheetForbiddenComponentHtmlUrl from './buySheetForbidden.component.html'

angular.module('buySheet.components').component('buySheetForbidden', {
    templateUrl: buySheetForbiddenComponentHtmlUrl,
})